import React from "react";

const IconChevronDown = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? "14.459"}
      height={props.height ?? "8.229"}
      viewBox="0 0 14.459 8.229"
      className="select-icon"
      {...props}
    >
      <path
        id="chevron-down"
        d="M11.63,5.815,5.815,0,0,5.815"
        transform="translate(13.045 7.229) rotate(180)"
        fill="none"
        stroke={props.color ?? "#828080"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
    </svg>
  );
};

export default IconChevronDown;
